import { styles } from "./Popin.style";
import * as React from "react";
import { DialogContent, Dialog, DialogTitle, /*IconButton,*/ WithStyles, withStyles } from "@material-ui/core";
// import CloseIcon from "@material-ui/icons/Close";

interface PopinProps {
    title: string;
    open: boolean;
    maxWidth: "xs" | "sm" | "md" | false;
    onClick?();
}

class Popin extends React.Component<PopinProps & WithStyles<typeof styles>> {

    public render() {

        const {classes, /*theme,*/ children, /*onClick,*/ open, title, maxWidth} = this.props;

        return (
                <Dialog open={open} maxWidth={maxWidth} scroll="body" className={classes.popin}>
                    <DialogContent className={classes.content}>
                        <DialogTitle className={classes.header}>
                            {title}
                            {/*<IconButton onClick={onClick}>*/}
                                {/*<CloseIcon nativeColor={theme.palette.primary.main}/>*/}
                            {/*</IconButton>*/}
                        </DialogTitle>

                        {children}

                    </DialogContent>
                </Dialog>
        );
    }

}

export default withStyles(styles, {withTheme: true})(Popin);


// WEBPACK FOOTER //
// ./src/components/Popin/Popin.tsx